import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function ClientPreferencesIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'Grey6', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    return (_jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: _jsx("path", { d: "M5.648 17.265L2 13.059l1.524-1.647 3.195 2.475L16.024 4l1.667.824-9.447 12.362a1.672 1.672 0 01-1.279.653 1.676 1.676 0 01-1.317-.574zM17.691 7.294h4.167v1.647h-4.167zM14.359 11.412h7.5v1.647h-7.5zM11.859 15.529h10v1.647h-10z", fill: primaryFillColor }) }));
}
//# sourceMappingURL=ClientPreferences.js.map